var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94795 6.26992H20.5303C21.1197 6.26992 21.5975 6.74772 21.5975 7.33711V17.1676C21.5975 17.757 21.1197 18.2348 20.5303 18.2348H5.94795C5.35856 18.2348 4.88076 17.757 4.88076 17.1676V7.33711C4.88076 6.74772 5.35856 6.26992 5.94795 6.26992Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31648 17.9121H23.1612C23.1818 17.9121 23.2015 17.9203 23.216 17.9348C23.2306 17.9494 23.2388 17.9691 23.2388 17.9897V18.6391C23.2388 18.7561 23.1923 18.8683 23.1096 18.951C23.0269 19.0337 22.9147 19.0802 22.7977 19.0802H3.67996C3.56298 19.0802 3.45079 19.0337 3.36807 18.951C3.28535 18.8683 3.23888 18.7561 3.23888 18.6391V17.9938C3.23832 17.9833 3.23992 17.9727 3.24357 17.9628C3.24722 17.953 3.25285 17.9439 3.26011 17.9363C3.26737 17.9286 3.27611 17.9225 3.28581 17.9184C3.2955 17.9142 3.30593 17.9121 3.31648 17.9121Z",
    fill: "#363A45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0619 7.4082H6.89778C6.78122 7.41667 6.66759 7.44875 6.56381 7.50249C6.46003 7.55624 6.36826 7.63052 6.29408 7.72083C6.21989 7.81114 6.16485 7.91559 6.13228 8.02783C6.09972 8.14007 6.09032 8.25776 6.10465 8.37375V16.1326C6.09032 16.2486 6.09972 16.3663 6.13228 16.4786C6.16485 16.5908 6.21989 16.6952 6.29408 16.7856C6.36826 16.8759 6.46003 16.9501 6.56381 17.0039C6.66759 17.0576 6.78122 17.0897 6.89778 17.0982C10.26 17.0637 17.0619 11.1411 17.0619 7.4082Z",
    fill: "#00C65E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.2d3d7faef4cc1b60d66d504fe1a1f271.svg";
export { ForwardRef as ReactComponent };